/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import { Col, Row, Space, Radio } from 'antd'
import { formValidation, isBefore, isFormError, isFormRequired, numberWithComma } from 'helpers/format'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import ConfirmWithChild from 'Components/modal/ConfirmWithChild'
import { AppInput, AppSelect, MultiUploadForm } from 'Components/form'
import { ConfirmDailog } from 'Components/modal'
import { cloneDeep } from 'lodash'
import { menuSupplierPaymentTypes, PaymentTypes } from 'helpers/constanst'
import AppDateItem from 'Components/form/AppDateItem'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { connect } from 'react-redux'
import { PaymentReq } from 'Store/supplier-invoice/types'
import moment from 'moment'

type Props = {
  visible: boolean
  onCloseModal: () => void
  onConfirm?: (req: PaymentReq) => void
  depy_amount?: number
  init_info: PaymentReq
} & ReduxProps

const PaymentModal: React.FunctionComponent<Props> = props => {
  const { onCloseModal, visible, onConfirm = () => {}, depy_amount = 0, currentUser, init_info } = props
  const [formData, setFormData] = useState(cloneDeep(init_info))
  const [confirmDialog, setConfirmDialog] = useState(false)
  const [amountType, setAmountType] = useState('full')
  const [formError, setFormError] = useState([] as string[])
  const requireFeild = ['payment_channel', 'payment_date']

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  useEffect(() => {
    if (visible) {
      setFormData(cloneDeep(init_info))
    }
  }, [visible])

  // useEffect(() => {
  //   if (!visible) {
  //     setAmount(0)
  //     setAmountType('full')
  //   }
  // }, [visible])

  useEffect(() => {
    if (amountType === 'full') {
      setFormData({
        ...formData,
        amount: depy_amount,
      })
    }
  }, [amountType])

  const onUpdateAmount = (val: any) => {
    let newAmount = parseFloat(val)
    if (newAmount > depy_amount) {
      newAmount = depy_amount
    }
    setFormData({
      ...formData,
      amount: newAmount,
    })
    // if (detail) {
    //   setDetail({ ...detail, total_recieve_price: newAmount })
    // }
  }

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const onUpdateData = (val: string, key: string) => {
    setFormData({
      ...formData,
      [key]: val,
    })
  }

  const ConfirmApproveDailog = (
    <ConfirmDailog
      title="ยืนยันการชำระเงิน"
      description={`คุณแน่ใจที่จะชำระเงินหรือไม่`}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmDialog}
      handleOk={() => {
        setConfirmDialog(false)
        onConfirm(formData)
      }}
      handleCancel={() => setConfirmDialog(false)}
      loading={false}
    />
  )

  const paymentForm = () => {
    return (
      <BoxWrapper>
        <Row gutter={[30, 12]}>
          <Col md={12} xs={24}>
            <Row gutter={[8, 8]}>
              <Col md={24} xs={24}>
                <AppSelect
                  name="payment_channel"
                  label="รูปแบบการชำระเงิน"
                  isRequired={isRequired('payment_channel')}
                  isError={isError('payment_channel')}
                  value={formData.payment_channel}
                  onChange={onUpdateData}
                  menu={menuSupplierPaymentTypes}
                />
              </Col>
              <Col md={24} xs={24}>
                <AppDateItem
                  label="วันที่ชำระเงิน"
                  placeHolder={'วันที่ชำระเงิน'}
                  isRequired={isRequired('payment_date')}
                  isError={isError('payment_date')}
                  onChange={(date: string) => onUpdateData(date, 'payment_date')}
                  date={formData.payment_date}
                  showTime={true}
                  disableDate={(date: any) => {
                    return formData.payment_channel == PaymentTypes.CHECK
                      ? undefined
                      : isBefore(
                          moment(date)
                            .subtract(0, 'days')
                            .startOf('day')
                            .toString(),
                        )
                  }}
                />
              </Col>
              <Col md={24} xs={24}>
                <AppInput
                  name="reason"
                  label="หมายเหตุ"
                  isRequired={isRequired('reason')}
                  isError={isError('reason')}
                  value={formData.reason}
                  onChange={onUpdateData}
                />
              </Col>
            </Row>
          </Col>
          <Col md={12} xs={24}>
            <Row>
              <Col md={24} xs={24}>
                <MultiUploadForm
                  token={currentUser.accessToken}
                  onUpdateData={onUpdateData}
                  files={formData.payment_slips || []}
                  folder="supplier-payment-slips"
                  isPrivate={true}
                  name="payment_slips"
                  description="ขนาดไม่เกิน 5MB ต่อไฟล์ (.png .jpg .pdf) สามารถอัพโหลดได้มากกว่า 1 รายการ"
                  isRequired={isRequired('payment_slips')}
                  isError={isError('payment_slips')}
                  label="Upload หลักฐานการรับชำระเงิน"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </BoxWrapper>
    )
  }

  const renderConfirmInfo = () => {
    return (
      <>
        <ConfirmWrapper>
          <Row gutter={[8, 16]}>
            <Col span={24}>
              <Row justify="space-between" align="middle" gutter={[32, 8]}>
                <Col>
                  <Space>
                    ยอดที่ต้องชำระ <Price>{numberWithComma(depy_amount, true)}</Price> บาท
                  </Space>
                </Col>
                <Col>
                  <Radio.Group value={amountType} onChange={e => setAmountType(e.target.value)}>
                    <Radio.Button value="full">ชำระเต็มจำนวน</Radio.Button>
                    <Radio.Button value="patial">ชำระไม่เต็มจำนวน</Radio.Button>
                  </Radio.Group>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <AppInput
                name="price_c"
                label={''}
                isRequired={true}
                isError={false}
                value={formData.amount}
                onChange={onUpdateAmount}
                type="number"
                resProps={{ suffix: 'บาท', disabled: amountType === 'full' }}
              />
            </Col>
          </Row>
        </ConfirmWrapper>
        {paymentForm()}
      </>
    )
  }

  return (
    <>
      {ConfirmApproveDailog}
      <ConfirmWithChild
        title={'ระบุจำนวนเงินที่ต้องการชำระ'}
        isShow={visible}
        handleOk={() => {
          if (!validateForm()) return
          setConfirmDialog(true)
        }}
        handleCancel={onCloseModal}
        child={renderConfirmInfo()}
        cancelBtnTxt="ยกเลิก"
        confirmBtnTxt="ยืนยันชำระหนี้"
        width={'50%'}
      />
    </>
  )
}

const Price = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
`
const ConfirmWrapper = styled.div`
  padding: 10px;
  text-align: left;
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  text-align: left;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PaymentModal)
